import { render, staticRenderFns } from "./SharedLinks.vue?vue&type=template&id=26813b04&"
import script from "./SharedLinks.vue?vue&type=script&lang=js&"
export * from "./SharedLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports